import {PollType} from '../../../../shared/models/poll';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppActions} from '../../../actions';
import {PollResponsePayload} from '../../../../shared/models/api';

export interface PollsListState {
  surveys: PollResponsePayload[] | null;
  votes: PollResponsePayload[] | null;
}

const initialState: PollsListState = {votes: null, surveys: null};

export const pollsListSlice = createSlice({
  name: '@@eskso/polls/list',
  initialState,
  reducers: {
    setPolls: (state, action: PayloadAction<PollResponsePayload[]>) => {
      return {
        ...state,
        surveys: action.payload?.filter((item) => item.typeId === PollType.Survey) ?? [],
        votes: action.payload?.filter((item) => item.typeId === PollType.Voting) ?? [],
      };
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});
